import React, { Component, ReactElement, RefObject, createRef, ChangeEvent } from "react"
import { isSmallScreen } from "../Utils/Helpers"

export interface DropDownItem {
  id: string
  title: string
}

export interface DropDownProps {
  children: ReactElement
  onSelect: (dropDownItem: DropDownItem) => void
  list: DropDownItem[]
  selectedId?: string
  className?: string
  position?: "top" | "bottom"
}

export interface DropDownStates {
  showDropDown: boolean
  isMobile: boolean
}

export class DropDown extends Component<DropDownProps, DropDownStates> {
  private ref: RefObject<HTMLDivElement>
  private selectRef: RefObject<HTMLSelectElement>
  private readonly handleOutsideClick: (event: Event) => void

  constructor(props: DropDownProps) {
    super(props)
    this.ref = createRef()
    this.selectRef = createRef()
    this.handleOutsideClick = (event) => this.outsideClick(event)
    this.state = { showDropDown: false, isMobile: isSmallScreen() }
  }

  componentDidMount() {
    document.body.addEventListener("click", this.handleOutsideClick, true)
    window.addEventListener("resize", this.handleResize, true)
  }

  componentWillUnmount() {
    document.body.removeEventListener("click", this.handleOutsideClick)
    window.removeEventListener("resize", this.handleResize)
  }

  handleResize = () => {
    this.setState({ isMobile: isSmallScreen() })
  }

  handleMobileSelect = (event: ChangeEvent<HTMLSelectElement>) => {
    const option = event.target
    const value = option.value
    const item = this.props.list.find((item) => item.id === value)
    item && this.props.onSelect(item)
    event.preventDefault()
  }

  outsideClick(event: Event) {
    if (this.state.isMobile) {
      return
    }
    const target = event.target
    const current = this.ref.current
    if (current && !current.contains(target as HTMLDivElement)) {
      this.setState({ showDropDown: false })
    }
  }

  toggleDropDown = () => {
    if (this.state.isMobile) {
      return
    }
    const showDropDown = !this.state.showDropDown
    this.setState({ showDropDown })
  }

  render() {
    const { children, className, position, onSelect, list, selectedId } = this.props
    const selectedClass = "photoselector-sorting-circle-selected"
    const notSelectedClass = "photoselector-sorting-circle"
    const { showDropDown, isMobile } = this.state
    return (
      <div ref={this.ref} className={`photoselector-dropdown-container ${showDropDown ? "opened" : ""}`} onClick={this.toggleDropDown}>
        {children}
        {showDropDown && !isMobile ? (
          <div className={`photoselector-dropdown ${className || ""} ${position || "top"}`}>
            <div className="list">
              {list.map((item) => (
                <div className="list-item" key={item.id} onClick={() => onSelect(item)}>
                  <span className={item.id === selectedId ? selectedClass : notSelectedClass}></span>
                  <span className="photoselector-dropdown-items">{item.title}</span>
                </div>
              ))}
            </div>
            <div className={`photoselector-dropdown-arrow ${position}`}></div>
          </div>
        ) : null}
        {isMobile ? (
          <select className="photoselector-dropdown-select" value={selectedId} ref={this.selectRef} onChange={this.handleMobileSelect}>
            {list.map((item) => (
              <option key={item.id} value={item.id}>
                {item.title}
              </option>
            ))}
          </select>
        ) : null}
      </div>
    )
  }
}
